import { useState, useEffect } from 'react';
import { MaquinasService } from '../services/maquinasService';
import type { Maquina } from '../types';

export interface UseMaquinasReturn {
  maquinas: Maquina[];
  cargandoMaquinas: boolean;
  errorMaquinas: string | null;
}

/**
 * Hook para cargar lista de máquinas para formularios
 */
export const useMaquinas = (): UseMaquinasReturn => {
  const [maquinas, setMaquinas] = useState<Maquina[]>([]);
  const [cargandoMaquinas, setCargandoMaquinas] = useState(false);
  const [errorMaquinas, setErrorMaquinas] = useState<string | null>(null);

  useEffect(() => {
    const cargarMaquinas = async () => {
      setCargandoMaquinas(true);
      setErrorMaquinas(null);
      
      try {
        const listaMaquinas = await MaquinasService.obtenerListaMaquinas();
        setMaquinas(listaMaquinas);
      } catch (error: any) {
        setErrorMaquinas(error.message || 'Error al cargar máquinas');
        setMaquinas([]);
      } finally {
        setCargandoMaquinas(false);
      }
    };

    cargarMaquinas();
  }, []);

  return {
    maquinas,
    cargandoMaquinas,
    errorMaquinas
  };
};

export default useMaquinas;
